import { render, staticRenderFns } from "./DuaMessageReasonField.vue?vue&type=template&id=108d29a8"
import script from "./DuaMessageReasonField.vue?vue&type=script&lang=js"
export * from "./DuaMessageReasonField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports